import React from 'react';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import FourOFour from 'Component/FourOFour/FourOFour';

const FourOFourPage = () => {
	return (
		<Layout>
			<SEO title="404: Page not found" description="" />
			<FourOFour />
		</Layout>
	);
};

export default FourOFourPage;
